module.exports = __webpack_public_path__ + "static-portal/img/8.3a94fc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/8.jpg
// module id = MNtS
// module chunks = 4